module.exports = __webpack_public_path__ + "img/涂宇欣.addccee9.jpg";